import axios from 'axios'
import Util from '../utils'

class WebServiceConnector {
  constructor (exceptionHandler) {
    this.hostname = 'https://nlp.insightera.co.th/api'
    this.anonymousInstance = axios.create({
      baseURL: this.hostname,
      timeout: 30000,
      headers: {
        'content-type': 'application/json'
      }
    })
    const timeout = 1000 * 60 * 15
    this.anonymousInstanceFormData = axios.create({
      baseURL: this.hostname,
      timeout: timeout,
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
    this.authenticateInstance = this.anonymousInstance
    this.authenticateInstanceFormData = this.anonymousInstanceFormData
    this.exceptionHandler = exceptionHandler
  }

  setNewToken (token) {
    this.authenticateInstance = axios.create({
      baseURL: this.hostname,
      timeout: 30000,
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${token}`
      }
    })
  }

  async authRequest (url, requestBodyJson) {
    try {
      const result = await this.authenticateInstance.post(url, requestBodyJson)
      return result
    } catch (e) {
      if (e && e.response && e.response.status === 401) { // unauthorized
        throw new Error('Unauthorized')
      } else {
        throw e
      }
    }
  }

  async authFormDataRequest (url, FormData) {
    try {
      const result = await this.authenticateInstanceFormData.post(url, FormData)
      return result
    } catch (e) {
      if (e && e.response && e.response.status === 401) { // unauthorized
        throw new Error('Unauthorized')
      } else {
        throw e
      }
    }
  }

  async authGetRequest (url) {
    try {
      const result = await this.authenticateInstance.get(url)
      return result
    } catch (e) {
      if (e && e.response && e.response.status === 401) { // unauthorized
        throw new Error('Unauthorized')
      } else {
        throw e
      }
    }
  }

  async getTokenUsage () {
    const result = await this.authRequest('/web/token-usage', {
      token: '14c89c73e906563ec7aa14919fde491f',
      start: 1565589081000,
      stop: 1567589081000,
      binSize: 30
    })
    return result.data.result
  }

  async getProjectUsage (data) {
    try {
      const result = await this.authRequest('/web/project-usage', {
        projectId: data.projectId,
        start: data.start,
        stop: data.stop,
        binSize: data.binSize
      })
      return result.data.result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getProjectResponse (data) {
    try {
      const result = await this.authRequest('/web/project-time', {
        projectId: data.projectId,
        start: data.start,
        stop: data.stop,
        binSize: data.binSize
      })
      return result.data.result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getAllProject (userId) {
    try {
      const result = await this.authRequest('/web/all-projects', {
        userId: userId
      })
      if (!result) {
        return result
      }
      if (result.data.projects) {
        // for (let i = 0; i < result.data.projects.length; i++) {
        //   result.data.projects[i].name = Util.capitalizeFirstLetter(result.data.projects[i].name)
        //   result.data.projects[i].description = Util.capitalizeFirstLetter(result.data.projects[i].description)
        // }
        return result.data
      }
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getProjectDetail (projectId) {
    try {
      const result = await this.authRequest('/web/project-detail', {
        projectId: projectId
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getProjectErrorCount (projectId) {
    try {
      const result = await this.authRequest('/web/error-count', {
        projectId: projectId
      })
      return result.data.count
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getProjectService (data) {
    try {
      const result = await this.authRequest('/web/project-service-request-and-error-count-by-token', {
        projectId: data.projectId,
        start: data.start,
        stop: data.stop
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async addProject (userId, data) {
    try {
      const result = await this.authRequest('/user/add-project', {
        userId: userId,
        billDate: data.billDate,
        projectName: data.name,
        description: data.description
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async deleteProject (userId, projectId) {
    try {
      const result = await this.authRequest('/user/delete-project', {
        userId: userId,
        projectId: projectId
      })
      return result.data.message
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getServiceList () {
    try {
      const result = await this.authRequest('/web/service-list')
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getPackageList () {
    try {
      const result = await this.authGetRequest('/web/package-list')
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getUsageQuota (data) {
    try {
      const result = await this.authRequest('/web/usage-quota', {
        projectId: data.projectId,
        tokenId: data.token
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getBlockedCount (data) {
    try {
      const result = await this.authRequest('/web/blocked-count', {
        projectId: data.projectId,
        tokenId: data.token
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async register (name, email, password) {
    try {
      const result = await this.anonymousInstance.post('/user/add', {
        name,
        email,
        password
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async login (email, password) {
    const result = await this.anonymousInstance.post('/auth/sign-in', {
      email,
      password
    })
    if (result.status === 200) {
      const data = result.data
      this.setNewToken(data.token)
      return {
        userId: data.userId,
        email: data.info.email,
        name: data.info.name,
        phone: data.info.phone,
        authToken: data.token,
        authTokenExpireAt: data.expire,
        profilePicture: data.profilePicture,
        isLdapUser: data.isLdapUser
      }
    } else {
      throw new Error('Unable to authenticate')
    }
  }

  async verifyEmail (params) {
    try {
      const result = await this.anonymousInstance.get('/user/verify', {
        params
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async forgotPassword (email) {
    try {
      const result = await this.anonymousInstance.post('/user/forgot-password', {
        email: email
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async resetPassword (newPassword, token, source) {
    try {
      const result = await this.anonymousInstance.post(`/user/reset-password?token=${token}&source=${source}`, {
        newPassword
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async refreshToken () {
    try {
      const result = await this.authRequest('/auth/refresh')
      if (result.status === 200) {
        const data = result.data
        const authToken = data.token
        const authTokenExpireAt = data.expire
        this.setNewToken(authToken)
        return {
          authToken: authToken,
          authTokenExpireAt: authTokenExpireAt
        }
      } else {
        throw new Error('Unable to refresh token')
      }
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async createNewToken (projectId, userId, name) {
    try {
      const result = await this.authRequest('/token/generate', {
        userId,
        projectId,
        name
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getTokensDetail (projectId) {
    try {
      const result = await this.authRequest('/web/token-detail', { projectId })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  // TODO actualy send request to get single token not filter out token like this
  async getTokenDetail (projectId, token) {
    try {
      const response = await this.getTokensDetail(projectId)
      const tokensDetail = response.data || []
      const tokenDetail = tokensDetail.find(tokenDetail => tokenDetail.token === token)
      return tokenDetail
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getSingleTokenDetail (token) {
    try {
      const result = await this.authRequest('/web/token-single', {
        tokenId: token
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getSingleTokenDeepDetail (token) {
    try {
      const result = await this.anonymousInstance.post('/web/token-detail-new', {
        tokenId: token
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async addServiceToToken (token, serviceId, quota = {
    minute: 10,
    day: 2000,
    month: 20000
  }) {
    try {
      const result = await this.authRequest('/token/add-quota', {
        tokenId: token,
        service: serviceId,
        quota
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async addPackageToToken (token, packageName, quota = {
    minute: 10,
    day: 2000,
    month: 20000
  }) {
    try {
      const result = await this.authRequest('/token/add-package', {
        tokenId: token,
        package: packageName,
        quota
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async editPackageInToken (token, packageName, quota, name) {
    try {
      const result = await this.authRequest('/token/edit-package', {
        tokenId: token,
        name: name,
        package: packageName,
        quota
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async deletePackageFromToken (token, packageName) {
    try {
      const result = await this.authRequest('/token/delete-package', {
        token: token,
        package: packageName
      })
      return result.data
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async editQuota (token, serviceId, quota, name) {
    try {
      if (!quota.minute || !quota.day || !quota.month) {
        console.error('Invalid quota')
        return
      }

      const result = await this.authRequest('/token/edit-quota', {
        tokenId: token,
        service: serviceId,
        quota,
        name: name
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async removeServiceFromToken (token, serviceId) {
    try {
      const result = await this.authRequest('/token/delete-quota', {
        tokenId: token,
        service: serviceId
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async deleteToken (projectId, userId, token) {
    try {
      const result = await this.authRequest('/token/delete-token', {
        projectId,
        userId,
        tokenId: token
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async updateUserInfo (userInfo) {
    try {
      // Remove any parameter from URL before we sent it to our service (to prevent a bug) ?v=<unix_time>...
      userInfo.profilePicture = userInfo.profilePicture.split('?', 1)[0]
      const result = await this.authRequest('/user/update', userInfo)
      return result.status === 200 ? { profilePicture: `${result.data.profilePicture}?v=${Date.now()}`, info: result.data.info } : false
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async updatePassword (newPasswordData) {
    try {
      const result = await this.authRequest('/user/change-password', newPasswordData)
      return result.status === 200
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async updateProjectInfo (projectInfo) {
    try {
      const result = await this.authRequest('/user/edit-project', projectInfo)
      return result.status === 200 ? result.data.data : false
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async loggerFluentd (logData) {
    try {
      await this.authRequest('/web/log', logData)
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  // Classification
  async getModelDetailByModelId (modelId, token) {
    try {
      const result = await this.authRequest(`/nlp/classification/model?token=${token}`, {
        model_id: modelId
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async getModelListByToken (token) {
    try {
      // const result = []
      // const tokenList = Object.keys(data)
      // for (let i = 0; i < tokenList.length; i++) {
      //   const response = await this.authGetRequest(`/nlp/classification/token?token=${tokenList[i]}`)
      //   for (let j = 0; j < response.data.model_list.length; j++) {
      //     result.push(response.data.model_list[j])
      //   }
      // }
      const result = await this.authGetRequest(`/nlp/classification/token?token=${token}`)
      return result.data.model_list
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async trainWithFile (data) {
    const formData = new FormData()
    formData.append('file', data.file)
    if (data.model_name) {
      formData.append('model_name', data.model_name)
    }
    try {
      const result = await this.authFormDataRequest(`/nlp/classification/train-with-file?token=${data.token}`, formData)
      return result
    } catch (e) {
      if (e.response.status !== 400) {
        if (this.exceptionHandler) {
          this.exceptionHandler(e)
        } else {
          throw e
        }
      } else {
        return e
      }
    }
  }

  async trainWithJSONString (obj) {
    try {
      const result = await this.authRequest(`/nlp/classification/train?token=${obj.token}`, {
        is_sync: false,
        model_name: obj.model_name,
        data: obj.data
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async deleteModel (data) {
    try {
      const result = await this.authRequest(`/nlp/classification/delete?token=${data.token}`, {
        model_id: data.model_id
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }

  async changeModelName (data) {
    try {
      const result = await this.authRequest(`/nlp/classification/change-model-name?token=${data.token}`, {
        model_id: data.model_id,
        model_name: data.model_name
      })
      return result
    } catch (e) {
      if (this.exceptionHandler) {
        this.exceptionHandler(e)
      } else {
        throw e
      }
    }
  }
}

export default WebServiceConnector
